let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dWAyV")).then(() => parcelRequire('ge2sO'));